import {defineAsyncComponent} from 'vue';

//ĐVCQ
const summaryEstimateThreeYearDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryThreeYear/SummaryThreeYearEstimateDetail.vue'),
);

//STC

const SummaryThreeYearEstimateDistrictSTC = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryThreeYearSTC/tabs/SummaryThreeYearEstimateDistrictSTC.vue'),
);
const SummaryThreeYearEstimateProvinceSTC = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryThreeYearSTC/tabs/SummaryThreeYearEstimateProvinceSTC.vue'),
);

const SummaryThreeYearEstimateDetailSTC = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryThreeYearSTC/SummaryThreeYearEstimateDetailSTC.vue'),
);

export function registerSummaryEstimateThreeYear(app) {
  app.component('SummaryThreeYearEstimateDetail', summaryEstimateThreeYearDetail);
  app.component('SummaryThreeYearEstimateDetailSTC', SummaryThreeYearEstimateDetailSTC);
  app.component('SummaryThreeYearEstimateProvinceSTC', SummaryThreeYearEstimateProvinceSTC)
  app.component('SummaryThreeYearEstimateDistrictSTC', SummaryThreeYearEstimateDistrictSTC)
}
